module.exports = __webpack_public_path__ + "fonts/AntykwaTorunskaCond-BoldItalic.dd6aa952.ttf";